// app/javascript/channels/consumer.js
import { createConsumer } from '@rails/actioncable';

const domain = window.location.hostname;
const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
const port = window.location.port ? `:${window.location.port}` : '';

const userId = document.querySelector('meta[name=\'current-crmuser-id\']')?.content || '';

const url = `${protocol}://${domain}${port}/cable?crmuser_id=${encodeURIComponent(
  userId
)}`;

const Cable = createConsumer(url);

export default Cable;
